var React = require('react');

function LogoIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.884.027c7.844.476 14.06 7.042 14.06 15.072 0 8.339-6.703 15.099-14.972 15.099 0 0-5.549 0-8.631.71a19.728 19.728 0 0 0-5.037 1.95A.88.88 0 0 1 0 32.08V15.264C0 6.54 7.248-.496 15.884.027zm3.672 16.036a1.397 1.397 0 1 0-2.794 0 1.397 1.397 0 0 0 2.794 0zm.074 8.474h-8.885c-.92 0-1.666-.632-1.666-1.412V8.395c0-.78.746-1.41 1.666-1.41h8.885c.92 0 1.666.63 1.666 1.41v14.73c0 .78-.746 1.412-1.666 1.412","fill":"currentColor","fillRule":"evenodd"}));
}

LogoIcon.defaultProps = {"width":"30","height":"33","viewBox":"0 0 30 33"};

module.exports = LogoIcon;

LogoIcon.default = LogoIcon;
